import { Injectable } from '@angular/core';
import { QueriesService } from 'src/app/core/services/queries.service';

@Injectable({
  providedIn: 'root'
})
export class CierreService {

  private TABLA_TAREAS_NOCTURNO: string = "proc_datamarts@datamart"
  private TABLA_TAREAS_CIERRE: string = "proc_cierremensual"

  constructor(
    private queriesService: QueriesService,
  ) { }


  async getTareasNocturno() {
    return await this.queriesService.table(this.TABLA_TAREAS_NOCTURNO)
      .select("cod_proc", "ejecutar", "estado", "ult_ejec", "nom_proc", "descrip", "mens_ok")
      .where({ cod_datm: '2', ejecutar: "S" })
      .orderBy("cod_proc asc")
      .execute()
  }

  async getTareaNocturno(cod_proc: string) {
    return await this.queriesService.table(this.TABLA_TAREAS_NOCTURNO).where({ cod_datm: '2', ejecutar: "S", cod_proc }).execute()
  }

  async getTareasCierre() {
    return await this.queriesService.table(this.TABLA_TAREAS_CIERRE)
      .select("ejecutar", "estado", "ult_ejec", "job_ide", "nom_proc", "descrip")
      .orderBy("job_ide asc")
      .execute()
  }

  async getTareaCierre(job_ide: string) {
    return await this.queriesService.table(this.TABLA_TAREAS_CIERRE).where({ job_ide }).execute()
  }
}
